import React, {useMemo} from "react";
import PropTypes from "prop-types";
import {Tooltip, Typography, useTheme} from "@mui/material";
import {isString} from "underscore";

const StyledTooltip = ({
  backgroundColor,
  children,
  disableHoverListener,
  enterDelay = 350,
  enterNextDelay = 350,
  interactive,
  ref,
  maxWidth,
  opacity,
  placement,
  spanProps = {},
  title,
}) => {
  const theme = useTheme();

  const styledTitle = useMemo(
    () => (isString(title) ? <Typography variant="caption">{title}</Typography> : title),
    [title],
  );

  const transitionProps = useMemo(() => {
    const isDarkTheme = theme.palette.mode === "dark";
    return {
      style: {
        backgroundColor: backgroundColor ?? theme.palette.grey[isDarkTheme ? "700" : "800"],
        borderRadius: 0,
        maxWidth,
        opacity: opacity ?? 1,
      },
    };
  }, [backgroundColor, theme.palette.mode, maxWidth, opacity]);

  return (
    <Tooltip
      title={styledTitle}
      disableHoverListener={disableHoverListener}
      disableInteractive={!interactive}
      placement={placement}
      enterDelay={enterDelay}
      enterNextDelay={enterNextDelay}
      TransitionProps={transitionProps}
    >
      <span ref={ref} data-testid="tooltip-wrapper" {...spanProps}>
        {children}
      </span>
    </Tooltip>
  );
};

StyledTooltip.propTypes = {
  backgroundColor: PropTypes.string,
  children: PropTypes.any,
  disableHoverListener: PropTypes.bool,
  enterDelay: PropTypes.number,
  enterNextDelay: PropTypes.number,
  interactive: PropTypes.bool,
  ref: PropTypes.any,
  maxWidth: PropTypes.number,
  opacity: PropTypes.number,
  placement: PropTypes.string,
  spanProps: PropTypes.object,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.node]),
};

export default StyledTooltip;
